export function NetflixLogo({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 111 30" className={className} fill="currentColor">
      <path d="M105.062 14.28L111 30c-1.75-.25-3.499-.563-5.28-.845l-3.345-8.686-3.437 7.969c-1.687-.282-3.344-.376-5.031-.595l6.03-13.622L94.468 0h5.063l3.062 7.874L105.875 0h5.062l-5.875 14.28zM90.47 0h-4.594v27.25c1.5.094 3.062.156 4.594.343V0zM79.656 24.5c-2.5-.563-4.968-.97-7.468-1.376V0h4.625v20.594c.938.156 1.905.25 2.843.469V24.5zM64.5 17.563V0h4.656v15.438c-1.594.625-3.156 1.312-4.656 2.125zm-16.563 6l-.438-3.594c1.5-.313 3.032-.625 4.625-.78v-3.345c-1.625.188-3.125.47-4.625.782V13.53h5.312V10.5H43.312V28.97c3.156-.5 6.344-.844 9.5-1.032v-3.062l-4.875.687zM28.344 10.5H24.97v14.563c-1.532 0-3.063.063-4.594.156V10.5h-3.375V7.375h11.344V10.5zM19.375 0v3.5H0V0h19.375zM19.375 7.094v3.5H0v-3.5h19.375zM19.375 14.156v3.5H0v-3.5h19.375z"/>
    </svg>
  );
}

export function PrimeLogo({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 100 30" className={className} fill="currentColor">
      <path d="M2.5 21.5C17.5 28.5 36.5 31 52.5 28c5-1 9.5-2.5 14-4.5 1-.5 2.5-1 1.5.5-1.5 2-5 5-7.5 6.5-.5.5 0 1 .5.5C70 27 84 20.5 90 14c1-1 .5-2.5-1-1.5-8 4-17 7-26 8.5-9 1.5-18.5 1-27.5-1.5C26 17.5 17 13.5 9 8c-1-.5-2 0-1.5 1 2 4 4.5 8.5 7.5 12-.5 0-8-1-12-2.5-1-.5-1.5.5-.5 3zm70-16C67 2 60 0 52 0 42 0 32 3 25 9c-1 .5 0 1.5 1 1C33 5.5 42 3 52 3c8 0 15.5 1.5 22 5 1 .5 2-.5.5-2.5z"/>
    </svg>
  );
}

export function HotstarLogo({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
    </svg>
  );
}

export function PlayIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="5 3 19 12 5 21 5 3" fill="currentColor" stroke="none" />
    </svg>
  );
}
